var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5976 2.08696C6.35412 4.52174 3.99454 6.95652 1.63496 12.1739C-1.51115 19.0435 -0.0254857 28.087 5.30542 33.8261C8.18935 36.9565 15.3555 40 19.8999 40C24.4442 40 31.6104 36.9565 34.4943 33.8261C37.4656 30.6087 40 24.2609 40 20C40 15.4783 36.9413 8.34783 33.7952 5.47826C30.5617 2.52174 24.1821 0 19.8999 0C17.5403 0 14.2194 0.869564 11.5976 2.08696ZM27.3282 3.3913C33.97 6.34782 38.2522 13.2174 38.2522 20.8696C38.2522 24.4348 35.3682 31.1304 33.533 31.8261C32.8339 32.087 30.4743 31.4783 28.2895 30.5217C23.7451 28.5217 23.3081 27.2174 26.0173 22.7826C27.9399 19.7391 28.4643 11.5652 26.8912 8.78261C24.7938 4.78261 15.9672 4.34782 13.3455 8.08696C11.3355 10.8696 11.5976 19.3043 13.7824 22.7826C16.4916 27.2174 16.0546 28.5217 11.5102 30.5217C9.32545 31.4783 6.96587 32.087 6.26673 31.8261C4.25672 31.0435 1.54757 24.3478 1.54757 20.1739C1.46018 7.04348 15.4429 -2 27.3282 3.3913Z",
    fill: "#F0F1F9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSmall);
export default __webpack_public_path__ + "static/media/profile_small.204a41db82cce59e6f24a7f87c24a16b.svg";
export { ForwardRef as ReactComponent };